import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

/**
 * Firebase Configuration
 * Initialize Firebase app with your project credentials
 * 
 * IMPORTANT: Add your Firebase config to .env file:
 * REACT_APP_FIREBASE_API_KEY=your-api-key
 * REACT_APP_FIREBASE_AUTH_DOMAIN=your-auth-domain
 * REACT_APP_FIREBASE_PROJECT_ID=your-project-id
 * REACT_APP_FIREBASE_STORAGE_BUCKET=your-storage-bucket
 * REACT_APP_FIREBASE_MESSAGING_SENDER_ID=your-sender-id
 * REACT_APP_FIREBASE_APP_ID=your-app-id
 */

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://dalverha-737a5-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const database = getDatabase(app); 
export const functions = getFunctions(app);
export const storage = getStorage(app);

export default app;
